import * as React from 'react';
import { AppContext } from '../App';
import { IDocument, IExtraction, EToastVariant, IOrg } from '../types/my-types';
import useSessionStorage from '../components/hooks/useSessionStorage';

interface AppContextProviderProps {
  children: React.ReactNode;
}

export const AppContextProvider: React.FunctionComponent<AppContextProviderProps> = (props) => {
  const [accessibility, setAccessibility] = React.useState<boolean>(false);
  const [orgLabel, setOrgLabel] = useSessionStorage('org-label');
  const [showReviewSpreadsheet, setShowReviewSpreadsheet] = useSessionStorage('show-spreadsheet');

  const [orgId, setOrgId] = useSessionStorage('org-id');
  const [org, setOrg] = React.useState<IOrg>();
  // TODO: move dataPoolId out of local storage and use url params instead
  const [dataPoolId, setDataPoolId] = useSessionStorage('data-pool-id');
  const [dataPoolLabel, setDataPoolLabel] = useSessionStorage('data-pool-label');
  const [dataPoolTotal, setDataPoolTotal] = useSessionStorage('data-pool-total');
  const [isStaff, setIsStaff] = React.useState(false);

  const [toast, setToast] = React.useState({
    open: false,
    message: 'Glynt',
    variant: EToastVariant.info,
  });

  const [feedback, setFeedback] = React.useState({ open: false, message: '' });
  const [docs, setDocs] = React.useState<IDocument[]>();
  const [extractions, setExtractions] = React.useState<IExtraction[]>();
  // use ids for extraction_id or document_id
  // /reivew/:extraction_batch_id/extraction/:extraction_id
  // /mark/:training_set_id/document/:document_id
  const [ids, setIds] = React.useState<string[]>([]);
  const [extractionIndex, setExtractionIndex] = React.useState(0);
  const [maintenance, setMaintenance] = React.useState(false);
  let maintenanceMode = sessionStorage.getItem('maintenance');
  // console.log({ maintenanceMode });
  React.useEffect(() => {
    if (maintenanceMode && maintenanceMode === 'on') {
      setMaintenance(true);
    }
  }, [maintenanceMode]);
  sessionStorage.removeItem('maintenance');
  return (
    <AppContext.Provider
      value={{
        accessibility,
        setAccessibility,
        orgLabel: orgLabel as string,
        setOrgLabel,
        orgId: orgId as string,
        setOrgId,
        showReviewSpreadsheet: showReviewSpreadsheet as boolean,
        setShowReviewSpreadsheet,
        dataPoolId: dataPoolId as string,
        setDataPoolId,
        dataPoolTotal: dataPoolTotal as number,
        setDataPoolTotal,
        dataPoolLabel: dataPoolLabel as string,
        setDataPoolLabel,
        isStaff,
        setIsStaff,
        feedback,
        setFeedback,
        toast,
        setToast,
        docs,
        setDocs,
        extractions,
        setExtractions,
        ids,
        setIds,
        extractionIndex,
        setExtractionIndex,
        maintenance,
        setMaintenance,
        org,
        setOrg,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
